// extracted by mini-css-extract-plugin
export default {"container":"ItemsList_container__4AhDO"};